import { Route, Routes, useLocation } from "react-router-dom";
import PrivateRoute from "./components/Routes/PrivateRoute";
import RoleRoute from "./components/Routes/RoleRoute";
import PublicOnlyRoute from "./components/Routes/PublicOnlyRoute";
import GlobalStyle from "./styles/Global.styles";
import Home from "./pages/Home/Home"
import Header from "./components/Headers/Header";
import CreatorHeader from "./components/Headers/CreatorHeader";
import Footer from "./components/Footer";
import EpisodeUpdatePage from "./pages/Creators/EpisodeUpdatePage";
import Login from "./pages/Users/Login";
import Signup from "./pages/Users/Signup";
import SignupEmail from "./pages/Users/SignupEmail";
import PasswordFind from "./pages/Users/PasswordFind";
import MyPage from "./pages/Users/MyPage";
import PasswordCheck from "./pages/Users/PasswordCheck";
import EditProfile from "./pages/Users/EditProfile";
import Withdraw from "./pages/Users/Withdraw";
import LibraryPage from "./pages/Users/LibraryPage";
import MyComments from "./pages/Users/MyComments";
import CreatorRegister from "./pages/Creators/CreatorRegister";
import MockVerify from "./pages/Users/MockVerify";
import CreatorDashbord from "./pages/Creators/CreatorDashbord";
import ContentHome from "./pages/Home/ContentHome";
import WebnovelDetailPage from "./pages/Contents/WebnovelDetailPage";
import WebtoonDetailPage from "./pages/Contents/WebtoonDetailPage";
import WebnovelViewer from "./pages/Contents/WebnovelViewer";
import WebtoonViewer from "./pages/Contents/WebtoonViewer";
import KeywordSearch from "./pages/Search/KeywordSearch";
import TitleCreatorSearch from "./pages/Search/TitleCreatorSearch";
import EpisodeCommentsPage from "./pages/Contents/EpisodeCommentsPage";
import PointTransactionPage from "./pages/Users/PointTransactionPage";
import NewContents from "./pages/Contents/NewContents";
import MasterpieceContents from "./pages/Contents/MasterpieceContents";
import RecommendKeywordContents from "./pages/Contents/RecommendKeywordContents";
import PointCharge from "./pages/Users/PointCharge";
import PaymentSuccess from "./pages/Payments/PaymentSuccess";
import PaymentFail from "./pages/Payments/PaymentFail";
import OAuthRedirectHandler from "./pages/Users/OAuthRedirectHandler";
import NewContentPage from "./pages/Creators/NewContentPage";
import MyContentList from "./pages/Creators/MyContentList";
import ContentUpdatePage from "./pages/Creators/ContentUpdatePage";
import DeleteRequestPage from "./pages/Creators/DeleteRequestPage";
import DeleteContentList from "./pages/Creators/DeleteContentList";
import ContentDashboard from "./pages/Creators/ContentDashboard";
import EpisodeRegistrationPage from "./pages/Creators/EpisodeRegistrationPage";
import EpisodeDashboard from "./pages/Creators/EpisodeDashboard";
import RevenueDashboard from "./pages/Creators/RevenueDashboard";
import PayoutAccountPage from "./pages/Creators/PayoutAccountPage";
import ContentDetailPage from "./pages/Creators/ContentDetailPage";
import EpisodeDetailPage from "./pages/Creators/EpisodeDetailPage";
import SettlementHistoryPage from "./pages/Creators/SettlementHistoryPage";
import AdminHeader from "./components/Headers/AdminHeader";
import AdminSettlementPage from "./pages/Admins/AdminSettlementPage";
import AdminDeletionRequestPage from "./pages/Admins/AdminDeletionRequestPage";

function Router() {
    const location = useLocation();
    const hideHeaderFooter =
        location.pathname === "/mock-verify" ||
        location.pathname === "/payment/success" ||
        location.pathname === "/payment/fail" ||
        location.pathname === "/oauth/callback" ||
        /^\/webnovels\/[^/]+\/viewer\/[^/]+$/.test(location.pathname) ||
        /^\/webtoons\/[^/]+\/viewer\/[^/]+$/.test(location.pathname) ||
        /^\/webnovels\/[^/]+\/viewer\/[^/]+\/comments$/.test(location.pathname) ||       // 웹소설 댓글 페이지
        /^\/webtoons\/[^/]+\/viewer\/[^/]+\/comments$/.test(location.pathname)
        ;

    const creatorHeader = location.pathname.startsWith("/creators");
    const isAuthenticated = !!localStorage.getItem("accessToken");
    const adminHeader = location.pathname.startsWith("/admin");

    return (
        <>
            <GlobalStyle />
            {!hideHeaderFooter && !creatorHeader && !adminHeader && <Header></Header>}
            {!hideHeaderFooter && creatorHeader && !adminHeader && <CreatorHeader />}
            {!hideHeaderFooter && !creatorHeader && adminHeader && <AdminHeader />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/webnovels" element={<ContentHome />} />
                <Route path="/webtoons" element={<ContentHome />} />
                <Route path="/webnovels/new" element={<NewContents contentType="WEBNOVEL" />} />
                <Route path="/webtoons/new" element={<NewContents contentType="WEBTOON" />} />
                <Route path="/contents/masterpiece" element={<MasterpieceContents contentType="ALL" />} />
                <Route path="/webnovels/masterpiece" element={<MasterpieceContents contentType="WEBNOVEL" />} />
                <Route path="/webtoons/masterpiece" element={<MasterpieceContents contentType="WEBTOON" />} />
                <Route path="/webnovels/recommend/by-keyword" element={<RecommendKeywordContents contentType="WEBNOVEL" />} />
                <Route path="/webtoons/recommend/by-keyword" element={<RecommendKeywordContents contentType="WEBTOON" />} />
                <Route path="/webnovels/:contentId" element={<WebnovelDetailPage />} />
                <Route path="/webtoons/:contentId" element={<WebtoonDetailPage />} />
                <Route path="/search/keyword" element={<KeywordSearch />} />
                <Route path="/search" element={<TitleCreatorSearch />} />
                <Route path="/oauth/callback" element={< OAuthRedirectHandler />} />
                <Route element={<PublicOnlyRoute />} >
                    <Route path="/users/login" element={<Login />} />
                    <Route path="/users/signup" element={<Signup />} />
                    <Route path="/users/signup/email" element={<SignupEmail />} />
                    <Route path="/users/find-password" element={<PasswordFind />} />
                </Route>

                <Route element={<PrivateRoute />} >
                    <Route path="/users/my-page" element={<MyPage />} />
                    <Route path="/users/check-password" element={<PasswordCheck />} />
                    <Route path="/users/edit" element={<EditProfile />} />
                    <Route path="/users/withdraw" element={<Withdraw />} />
                    <Route path="/points/history" element={<PointTransactionPage />} />
                    <Route path="/library/interests" element={<LibraryPage />} />
                    <Route path="/library/history" element={<LibraryPage />} />
                    <Route path="/library/my-comments" element={<MyComments />} />
                    <Route path="/creators/register" element={<CreatorRegister />} />
                    <Route path="/mock-verify" element={<MockVerify />} />
                    <Route path="/webnovels/:contentId/viewer/:episodeId" element={<WebnovelViewer />} />
                    <Route path="/webtoons/:contentId/viewer/:episodeId" element={<WebtoonViewer />} />
                    <Route path="/:contentType/:contentId/viewer/:episodeId/comments" element={<EpisodeCommentsPage />} />
                    <Route path="/points/charge" element={<PointCharge />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/fail" element={<PaymentFail />} />
                </Route>

                <Route element={<RoleRoute allowedRoles={["ROLE_CREATOR"]} />}>
                    <Route path="/creators/dashboard" element={<CreatorDashbord />} />
                    <Route path="/creators/contents/new" element={<NewContentPage />} />
                    <Route path="/creators/contents/list" element={<MyContentList />} />
                    <Route path="/creators/contents/:contentId" element={<ContentDetailPage />} />
                    <Route path="/creators/contents/:contentId/edit" element={<ContentUpdatePage />} />
                    <Route path="/creators/contents/:contentId/delete" element={<DeleteRequestPage />} />
                    <Route path="/creators/contents/delete" element={<DeleteContentList />} />
                    <Route path="/creators/contents/dashboard" element={<ContentDashboard />} />
                    <Route path="/creators/webnovels/:contentId/episodes/new" element={<EpisodeRegistrationPage />} />
                    <Route path="/creators/webtoons/:contentId/episodes/new" element={<EpisodeRegistrationPage />} />
                    <Route path="/creators/contents/episodes/dashboard" element={<EpisodeDashboard />} />
                    <Route path="/creators/webnovels/:contentId/episodes/:episodeId" element={<EpisodeDetailPage />} />
                    <Route path="/creators/webtoons/:contentId/episodes/:episodeId" element={<EpisodeDetailPage />} />
                    <Route path="/creators/:type/:contentId/episodes/:episodeId/edit" element={<EpisodeUpdatePage />} />
                    <Route path="/creators/revenue/dashboard" element={<RevenueDashboard />} />
                    <Route path="/creators/revenue/history" element={<SettlementHistoryPage />} />
                    <Route path="/creators/settlements/bank-account" element={<PayoutAccountPage />} />
                </Route>

                <Route element={<RoleRoute allowedRoles={["ROLE_ADMIN"]} />}>
                    <Route path="/admin/settlements" element={<AdminSettlementPage />} />
                    <Route path="/admin/contents/deletion-requests" element={<AdminDeletionRequestPage />} />
                </Route>

            </Routes>
            {!hideHeaderFooter && <Footer></Footer>}
        </>
    )
}

export default Router;